import { createContext, useContext, useMemo, useState } from "react";
import type { PropsWithChildren } from "react";

type ContactWidgetDataContextValue = {
    contactWidgetData: string[];
    setContactWidgetData: (data: string[]) => void;
};

const ContactWidgetDataContext = createContext<ContactWidgetDataContextValue | null>(null);
ContactWidgetDataContext.displayName = "ContactWidgetDataContext";

export const useContactWidgetDataContext = () => useContext(ContactWidgetDataContext);

type ProviderProps = PropsWithChildren;

export const ContactWidgetDataProvider = ({ children }: ProviderProps) => {
    const [contactWidgetData, setContactWidgetDataState] = useState<string[]>([]);

    const value = useMemo(
        () => ({ contactWidgetData, setContactWidgetData: setContactWidgetDataState }),
        [contactWidgetData, setContactWidgetDataState],
    );

    return <ContactWidgetDataContext.Provider value={value}>{children}</ContactWidgetDataContext.Provider>;
};
